var _path, _rect, _path2, _path3, _mask, _g, _rect2, _path4, _rect3, _path5, _rect4, _circle, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTasksClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 180,
    viewBox: "0 0 185 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 180C139.706 180 180 139.706 180 90C180 40.2944 139.706 0 90 0C40.2944 0 0 40.2944 0 90C0 139.706 40.2944 180 90 180Z",
    fill: "#0B0251"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 44,
    width: 92,
    height: 114,
    rx: 4,
    fill: "black",
    fillOpacity: 0.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 51C130 48.7909 131.791 47 134 47H134.901C136.725 47 138.318 48.2342 138.774 50.0005L141.873 62.0083C141.957 62.3348 142 62.6706 142 63.0078V133C142 135.209 140.209 137 138 137H134C131.791 137 130 135.209 130 133V51Z",
    fill: "black",
    fillOpacity: 0.47
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142 62.3881V129C142 131.209 140.209 133 138 133C135.791 133 134 131.209 134 129V62.1772L138 47L142 62.3881Z",
    fill: "#73C3F9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 47,
    width: 8,
    height: 86
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142 62.3881V129C142 131.209 140.209 133 138 133C135.791 133 134 131.209 134 129V62.1772L138 47L142 62.3881Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.073,
    y: 53.4696,
    width: 8.9,
    height: 15.9977,
    transform: "rotate(90 146.073 53.4696)",
    fill: "#3C21F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.949,
    y: 116.075,
    width: 6.675,
    height: 17.8,
    transform: "rotate(90 146.949 116.075)",
    fill: "#3C21F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.073,
    y: 121.796,
    width: 1.03211,
    height: 15.9977,
    transform: "rotate(90 146.073 121.796)",
    fill: "#0B0251"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 38.0367,
    width: 86.0642,
    height: 110.963,
    rx: 6.49541,
    fill: "#F3C364"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.45 38.0367H122.569C126.156 38.0367 129.064 40.9448 129.064 44.5321V142.505C129.064 146.092 126.156 149 122.569 149H114.45V38.0367Z",
    fill: "#E1B25F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.3303,
    y: 42.367,
    width: 77.4037,
    height: 101.761,
    rx: 1.62385,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9999 36.7064C67.9999 35.2117 69.2132 34 70.7079 34C82.2487 34 89.7512 34 101.292 34C102.787 34 104 35.2117 104 36.7064V46H67.9999V36.7064Z",
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.3119,
    y: 31,
    width: 25.4404,
    height: 7.0367,
    rx: 3.51835,
    fill: "#C4C4C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 36.5,
    r: 2.5,
    fill: "#0B0251"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54.367,
    y: 57.5229,
    width: 10.8257,
    height: 10.8257,
    rx: 2.70642,
    fill: "#DFE8FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 57.5229,
    width: 44.3853,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 79.1743,
    width: 44.3853,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 100.826,
    width: 44.3853,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 122.477,
    width: 44.3853,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 61.3119,
    width: 27.6055,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 83.5046,
    width: 27.6055,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 105.156,
    width: 27.6055,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 126.807,
    width: 27.6055,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 66.1835,
    width: 27.6055,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 87.8349,
    width: 27.6055,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 109.486,
    width: 27.6055,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0642,
    y: 131.138,
    width: 27.6055,
    height: 2.16514,
    rx: 1.08257,
    fill: "#DFE8FF",
    fillOpacity: 0.34
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 54.367,
    y: 79.1743,
    width: 10.8257,
    height: 10.8257,
    rx: 2.70642,
    fill: "#DFE8FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 54.367,
    y: 100.826,
    width: 10.8257,
    height: 10.8257,
    rx: 2.70642,
    fill: "#DFE8FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 54.367,
    y: 122.477,
    width: 10.8257,
    height: 10.8257,
    rx: 2.70642,
    fill: "#DFE8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0111 61.048C62.2271 60.8225 62.5773 60.8225 62.7933 61.048C63.0094 61.2735 63.0094 61.6391 62.7933 61.8645L59.4745 65.3288C59.2574 65.5553 58.9051 65.5541 58.6896 65.326L56.7636 63.2881C56.5491 63.0611 56.5515 62.6955 56.769 62.4716C56.9864 62.2477 57.3367 62.2502 57.5512 62.4772L59.086 64.1012L62.0111 61.048Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0111 82.6994C62.2271 82.4739 62.5773 82.4739 62.7933 82.6994C63.0094 82.9249 63.0094 83.2905 62.7933 83.5159L59.4745 86.9802C59.2574 87.2067 58.9051 87.2055 58.6896 86.9774L56.7636 84.9395C56.5491 84.7125 56.5515 84.3469 56.769 84.123C56.9864 83.8991 57.3367 83.9016 57.5512 84.1286L59.086 85.7526L62.0111 82.6994Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0111 104.351C62.2271 104.125 62.5773 104.125 62.7933 104.351C63.0094 104.576 63.0094 104.942 62.7933 105.167L59.4745 108.632C59.2574 108.858 58.9051 108.857 58.6896 108.629L56.7636 106.591C56.5491 106.364 56.5515 105.998 56.769 105.774C56.9864 105.55 57.3367 105.553 57.5512 105.78L59.086 107.404L62.0111 104.351Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0111 126.002C62.2271 125.777 62.5773 125.777 62.7933 126.002C63.0094 126.228 63.0094 126.593 62.7933 126.819L59.4745 130.283C59.2574 130.509 58.9051 130.508 58.6896 130.28L56.7636 128.242C56.5491 128.015 56.5515 127.65 56.769 127.426C56.9864 127.202 57.3367 127.204 57.5512 127.431L59.086 129.055L62.0111 126.002Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksClipboard);
export default __webpack_public_path__ + "static/media/tasks-clipboard.6238ece7a554496e4fc7960dd372aff9.svg";
export { ForwardRef as ReactComponent };